/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  PutApiProjectsIdMutationRequest,
  PutApiProjectsIdMutationResponse,
  PutApiProjectsIdPathParams,
} from '../models/PutApiProjectsId.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  putApiProjectsIdMutationResponseSchema,
  putApiProjectsIdMutationRequestSchema,
} from '../zod/putApiProjectsIdSchema.ts';
import { useMutation } from '@tanstack/react-query';

export const putApiProjectsIdMutationKey = () =>
  [{ url: '/api/projects/:id' }] as const;

export type PutApiProjectsIdMutationKey = ReturnType<
  typeof putApiProjectsIdMutationKey
>;

/**
 * {@link /api/projects/:id}
 */
export async function putApiProjectsId(
  id: PutApiProjectsIdPathParams['id'],
  data: PutApiProjectsIdMutationRequest,
  config: Partial<RequestConfig<PutApiProjectsIdMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = putApiProjectsIdMutationRequestSchema.parse(data);
  const res = await request<
    PutApiProjectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    PutApiProjectsIdMutationRequest
  >({
    method: 'PUT',
    url: `/api/projects/${id}`,
    data: requestData,
    ...requestConfig,
  });
  return putApiProjectsIdMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/projects/:id}
 */
export function usePutApiProjectsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PutApiProjectsIdMutationResponse,
      ResponseErrorConfig<Error>,
      {
        id: PutApiProjectsIdPathParams['id'];
        data: PutApiProjectsIdMutationRequest;
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PutApiProjectsIdMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? putApiProjectsIdMutationKey();

  return useMutation<
    PutApiProjectsIdMutationResponse,
    ResponseErrorConfig<Error>,
    {
      id: PutApiProjectsIdPathParams['id'];
      data: PutApiProjectsIdMutationRequest;
    },
    TContext
  >(
    {
      mutationFn: async ({ id, data }) => {
        return putApiProjectsId(id, data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
